var map = {
	"./1 Thumbnail, title_ Pengembangan Kompetensi Certified Forensic Auditor (CFrA).jpg": 54570,
	"./2 Thumbnail, title_ Kegiatan Workshop Evaluasi Mandiri Kapabilitas APIP.jpg": 94975,
	"./3 Thumbnail, title_ Demi Integritas Organisasi, Ittama BNN RI Gelar Workshop Penilaian Maturitas SPIP Terintegrasi.jpg": 64090,
	"./4 Thumbnail, title_ Diklat Certified Risk Management Officer (CRMO).jpg": 29408,
	"./5 Thumbnail, title_ Diklat Certified Human Resource Manager (CHRM) Ittama BNN.jpg": 14718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84740;